import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Submissions() {
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    document.title = "Hotel Atlanta | Submissions";

    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn !== 'true') {
      navigate('/login');
    }

    const storedData = JSON.parse(localStorage.getItem('submissions')) || [];
    setEntries(storedData);
  }, [navigate]);

  const handleClear = () => {
    if (window.confirm("Are you sure you want to clear all submissions?")) {
      localStorage.removeItem('submissions');
      setEntries([]);
    }
  };

  const handleDelete = (index) => {
    const updated = entries.filter((_, i) => i !== index);
    localStorage.setItem('submissions', JSON.stringify(updated));
    setEntries(updated);
  };

  return (
    <section id="contact-form" className="py-3">
      <div className="container">
        <h1 className="l-heading">
          <span className="text-primary">Saved</span> Submissions
        </h1>

        {entries.length === 0 ? (
          <p>No submissions found.</p>
        ) : (
          <>
            <div style={{ width: '1150px', margin: '30px auto 20px', transform: 'translateX(50px)' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ padding: '10px', border: '1px solid #ccc', backgroundColor: '#f7c08a' }}>Name</th>
                    <th style={{ padding: '10px', border: '1px solid #ccc', backgroundColor: '#f7c08a' }}>Email</th>
                    <th style={{ padding: '10px', border: '1px solid #ccc', backgroundColor: '#f7c08a' }}>Message</th>
                    <th style={{ padding: '0', border: 'none' }}></th> {/* Invisible Delete column header */}
                  </tr>
                </thead>
                <tbody>
                  {entries.map((entry, index) => (
                    <tr key={index}>
                      <td style={{ padding: '10px', border: '1px solid #ccc' }}>{entry.name}</td>
                      <td style={{ padding: '10px', border: '1px solid #ccc' }}>{entry.email}</td>
                      <td style={{ padding: '10px', border: '1px solid #ccc' }}>{entry.message}</td>
                      <td style={{ padding: '10px', border: 'none', textAlign: 'left' }}>
                        <button
                          onClick={() => handleDelete(index)}
                          style={{
                            backgroundColor: '#e74c3c',
                            color: '#fff',
                            border: 'none',
                            padding: '6px 12px',
                            borderRadius: '20px',
                            cursor: 'pointer'
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Centered clear button */}
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <button className="btn btn-light" onClick={handleClear}>
                Clear Submissions
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
}

export default Submissions;